export const NOTIFICATION_CHATWOOT =
  "https://qentaz-notification-chatwoot.herokuapp.com/whatsapp-notification";
export const SEND_MESSAGE =
  "https://qentaz-notification-chatwoot.herokuapp.com/send-whatsapp-msg";
